import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CookieServiceService } from '../cookie-service.service';
import { HelperService } from '../helper.service';
import { UtilisService } from '../utilis.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OTPComponent implements OnInit {
  IssueArr: { OTP: any; uuid: any; };
  IssueArr1: { uuid: any; };

  constructor(public helperService: HelperService, private router: Router, private ngZone: NgZone,
    private utilService: UtilisService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private cookieService: CookieServiceService, private route: ActivatedRoute) {
    this.uuid = history.state.uuid;
    this.phone_no = history.state.phone_no;
    var timer = setInterval(() => {
      {
        this.otpcall = true;
      }
    }, 10000)
  }
  userotp: any;
  uuid: any;
  phone_no: any;
  otp_response: any = "";
  solid: any = "";
  accountNumber: any = "";
  branchname: any = "";
  otpcall: Boolean = false;
  isDisabled: Boolean = true;
  generateOTPviacall() {
    try {
      this.IssueArr1 = ({
        uuid: this.uuid
      })
      this.helperService.makePostRequest(this.IssueArr1, "/sendotpviacall").subscribe(res => {
        this.spinner.hide();
        if (res.call_status === "S") {
          this.toast.success(res.msg, "");
        }
        else {
          this.toast.error(res.msg, "", {
            positionClass: 'toast-top-center'
          });
        }
      });
    }
    catch (Error) {
      this.toast.error("Unable to make Call", "", {
        positionClass: 'toast-bottom-right'
      });
    }
  }
  VALOTP() {
    try {
      this.IssueArr = ({
        OTP: this.utilService.Encryptdata(this.userotp),
        uuid: this.utilService.Encryptdata(this.uuid)
      })
      this.spinner.show();
      this.helperService.makePostRequest(this.IssueArr, "/validateOTP").subscribe((res) => {
        this.spinner.hide();
        if (this.utilService.Decryptdata(res.otpval_status) === "S") {
          this.solid = this.utilService.Decryptdata(res.solid);
          this.branchname = this.utilService.Decryptdata(res.branchname);
          this.accountNumber = this.utilService.Decryptdata(res.account_no);
          this.toast.success(this.utilService.Decryptdata(res.msg), "", {
            positionClass: 'toast-top-center'
          });
          this.utilService.setData(res);
          this.cookieService.setJWTCookie(res.token);
          this.utilService.setIsReloadedAfterLogin(false);
          this.router.navigateByUrl('/Home', {
            state:
            {
              accountNumber: this.accountNumber, solid: this.solid, branchname: this.branchname
            }
          });
          //this.ngZone.run(() => this.router.navigateByUrl('/CustomerPrint'));

        }
        else if (this.utilService.Decryptdata(res.otpval_status) === "F2") {
          this.otp_response = this.utilService.Decryptdata(res.msg);
          this.userotp = "";
        }
        else {
          this.toast.error(this.utilService.Decryptdata(res.msg), "", {
            positionClass: 'toast-top-center'
          });
          this.cookieService.clearTokenCookie();
          this.ngZone.run(() => this.router.navigateByUrl('/Default'));
        }
      },
        (err) => {
          if (err.status == 401) {
            this.spinner.hide();
            this.toast.error('', "Some Error Occured");
            this.cookieService.clearTokenCookie();
          }
        });
    }
    catch (Error) {
      this.spinner.hide();
      this.toast.error("Some error occured", "", {
        // positionClass: 'toast-bottom-right'
        positionClass: 'toast-top-center'
      });
    }
  }
  resendOTP() { }

  ngOnInit(): void {
  }
  disableGenerateButton() {
    this.userotp = (this.userotp ? this.userotp + "" : "");
    if (this.userotp && this.userotp.length > 0 && this.userotp.length === 6) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }
}
